module.exports = __webpack_public_path__ + "media/images/redesign-images/home/collegiate-logos/university-of-iowa-348819ddb369552e62bb207e1e258b33.svg";